import React, { FC } from 'react';
import classNames from 'classnames';
import { dateForOrderDetails } from '../../utils/date';
import { addSpaceNumber } from '../../utils/addSpaceNumber';
import styles from './InformationOrderBlock.module.scss';
import { useGetUnitMeasuresQuery } from 'redux/Api/ordersApi/ordersApi';
import { TIMEZONES } from 'constants/timezones';
interface InformationOrderBlockTypes {
  objectInfo?: Record<string, string | number>;
  className?: string;
  payment?: boolean;
  noPayment?: string;
}

export const InformationOrderBlock: FC<InformationOrderBlockTypes> = ({
  objectInfo,
  className,
  payment,
  noPayment,
}) => {
  const objectElements = [];
  const { data: dataUnits } = useGetUnitMeasuresQuery();

  const translateObj: Record<string, string> = {
    name: 'Наименование',
    inn: 'ИНН',
    kpp: 'КПП',
    phone: 'Телефон',
    email: 'E-mail',
    jur_address: 'Юридический адрес',
    legal_type: 'Тип организации',
    ogrn: 'ОГРН',
    address: 'Локация',
    description: 'Описание',
    order_type: 'Тип услуги ',
    date_start: 'Дата начала ',
    date_end: 'Дата окончания',
    amount: 'Стоимость',
    period: 'Период',
    customer_jur_name: 'Юр. лицо',
    taxes_on_virtual_account_amount: 'В копилке',
    taxes_accrued_amount: 'Начислено',
    taxes_paid_amount: 'Оплачено',
    date: 'Дата',
    recipient: 'Получатель ',
    total_amount: 'Сумма',
    worker_amount: 'Выплата',
    commission_amount: 'Вознаграждение оператора',
    tax_amount: 'В копилку',
    legal_entity: 'Заказчик',
    purpose: 'Назначение',
    requisites: 'Реквизиты',
    failure_description: 'Комментарий',
    bic: 'БИК',
    recipient_name: 'Наименование получателя',
    is_unit_based: 'Оплата за выполненный объем',
    unit_volume: 'Объем',
    unit_measure: 'Ед. измерения',
    unit_price: 'Цена за ед.',
    unit_volume_min: 'Мин. объем',
    unit_volume_max: 'Макс. объем',
    is_marketplace: 'Маркетплейс',
    timezone: 'Часовой пояс',
  };

  if (noPayment) {
    return <div>{noPayment}</div>;
  }

  if (!objectInfo) {
    return null;
  }

  for (const key in objectInfo) {
    if (Boolean(objectInfo[key])) {
      // eslint-disable-next-line no-prototype-builtins
      if (objectInfo.hasOwnProperty(key) && key in translateObj) {
        objectElements.push(
          <div className={styles.blockDetail} key={key}>
            <p className={styles.blockDetail_key}>{translateObj[key]} </p>
            <p className={styles.blockDetail_value}>
              {key.includes('date') && !payment
                ? dateForOrderDetails(String(objectInfo[key]))
                : key.includes('amount') || key.includes('price')
                ? `${addSpaceNumber(objectInfo[key])} ₽`
                : objectInfo[key] === 'I'
                ? 'ИП'
                : objectInfo[key] === 'J'
                ? 'Юридическое лицо'
                : objectInfo[key] === 'F'
                ? 'Физическое лицо'
                : key === 'is_unit_based'
                ? objectInfo[key] === 1
                  ? 'Да'
                  : 'Нет'
                : key === 'unit_measure'
                ? dataUnits?.[objectInfo[key] as keyof typeof dataUnits]
                : key === 'timezone'
                ? `${TIMEZONES.find((item) => item.value === objectInfo[key])?.label}`
                : key === 'is_marketplace'
                ? objectInfo[key] === 1
                  ? 'Да'
                  : 'Нет'
                : objectInfo[key]}
            </p>
          </div>,
        );
      } else {
        objectElements.push(
          <div className={styles.blockDetail} key={key}>
            <p className={styles.blockDetail_key}>{key} </p>
            <p className={styles.blockDetail_value}>{objectInfo[key]}</p>
          </div>,
        );
      }
    }
  }
  return (
    <div className={classNames(styles.blockDetailRoot, className)}>{objectElements}</div>
  );
};
